'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

var _package = require('../package.json');

var _package2 = _interopRequireDefault(_package);

var _responses = require('./responses');

var _Paginator = require('./Paginator');

var _Paginator2 = _interopRequireDefault(_Paginator);

var _getTransformResponse = require('./utils/getTransformResponse');

var _getTransformResponse2 = _interopRequireDefault(_getTransformResponse);

var _mergeRequestOptions = require('./utils/mergeRequestOptions');

var _mergeRequestOptions2 = _interopRequireDefault(_mergeRequestOptions);

var _ResponseTransformers = require('./utils/ResponseTransformers');

var _ResponseTransformers2 = _interopRequireDefault(_ResponseTransformers);

var _handleAuthRedirect = require('./utils/handleAuthRedirect');

var _handleAuthRedirect2 = _interopRequireDefault(_handleAuthRedirect);

var _urlJoin = require('./utils/urlJoin');

var _urlJoin2 = _interopRequireDefault(_urlJoin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DEFAULT_OPTIONS = {
  host: 'https://www.localmed.com',
  wrapResponse: _responses.wrapResponse,
  paginatorClass: _Paginator2.default,
  request: _axios2.default,
  maxRedirects: 0,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'User-Agent': 'localmed-api-js/' + _package2.default.version
  }
};

var Client = function () {

  /**
   * The LocalMed API Client.
   * @constructor
   * @param {Object} [options]
   * @param {String} [options.host=https://www.localmed.com] - host url
   * @param {Object} [options.headers] - Default headers for requests
   */
  function Client() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Client);

    this.defaultOptions = (0, _mergeRequestOptions2.default)(DEFAULT_OPTIONS, options);
    this.host = this.defaultOptions.host;
    delete this.defaultOptions.host;
    this._request = this.defaultOptions.request;
    delete this.defaultOptions.request;
    this._paginatorClass = this.defaultOptions.paginatorClass;
    delete this.defaultOptions.paginatorClass;
  }

  /**
   * Make a generic request.
   * @param {Object} options
   * @returns {Promise}
   * @see {@link https://github.com/mzabriskie/axios}
   */


  /**
   * Mixin an object to the Client prototype. This allows for dynamic addition
   * of resource methods for the browser.
   * @param {...Object} mixin - An object of methods to extend the prototype.
   */


  _createClass(Client, [{
    key: 'request',
    value: function request() {
      var _this = this;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var finalOptions = (0, _mergeRequestOptions2.default)(this.defaultOptions, options);
      finalOptions.url = (0, _urlJoin2.default)(this.host, finalOptions.url);
      return this._request(finalOptions).then(_handleAuthRedirect2.default).then(function (response) {
        return finalOptions.wrapResponse(_this, response);
      });
    }
  }, {
    key: 'get',
    value: function get(url) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return this.request(_extends({}, options, { url: url, method: 'get' }));
    }
  }, {
    key: 'post',
    value: function post(url, data) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      return this.request(_extends({}, options, { url: url, data: data, method: 'post' }));
    }
  }, {
    key: 'put',
    value: function put(url, data) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      return this.request(_extends({}, options, { url: url, data: data, method: 'put' }));
    }
  }, {
    key: 'delete',
    value: function _delete(url) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return this.request(_extends({}, options, { url: url, method: 'delete' }));
    }
  }, {
    key: 'getResourceList',
    value: function getResourceList(url, params) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      var finalOptions = _extends({}, options, { params: params, wrapResponse: _responses.wrapCollectionResponse });
      var transformResponse = (0, _getTransformResponse2.default)(finalOptions);
      if (finalOptions.resourceListKey) {
        transformResponse.push(_ResponseTransformers2.default.extractData(finalOptions.resourceListKey));
      }
      if (finalOptions.deserializer) {
        transformResponse.push(_ResponseTransformers2.default.deserializeResourceList(finalOptions.deserializer));
      }
      return this.get(url, finalOptions);
    }
  }, {
    key: 'getEntireResourceList',
    value: function getEntireResourceList(url) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      var request = this.getResourceList(url, _extends({}, params, { perPage: 100 }), options);
      var paginator = new this._paginatorClass();
      return paginator.getAll(request);
    }
  }, {
    key: 'getResource',
    value: function getResource(url) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var transformResponse = (0, _getTransformResponse2.default)(options);
      if (options.resourceKey) {
        transformResponse.push(_ResponseTransformers2.default.extractData(options.resourceKey));
      }
      if (options.deserializer) {
        transformResponse.push(options.deserializer);
      }
      return this.get(url, options);
    }
  }, {
    key: 'createResource',
    value: function createResource(url, data, options) {
      return this.post(url, data, _extends({}, options, { wrapResponse: _responses.wrapStatusResponse }));
    }
  }, {
    key: 'updateResource',
    value: function updateResource(url, data, options) {
      return this.put(url, data, _extends({}, options, { wrapResponse: _responses.wrapStatusResponse }));
    }
  }, {
    key: 'deleteResource',
    value: function deleteResource(url, options) {
      return this.delete(url, _extends({}, options, { wrapResponse: _responses.wrapStatusResponse }));
    }
  }]);

  return Client;
}();

Client.VERSION = _package2.default.version;

Client.mixin = function mixin() {
  for (var _len = arguments.length, mixins = Array(_len), _key = 0; _key < _len; _key++) {
    mixins[_key] = arguments[_key];
  }

  mixins.forEach(function (mix) {
    return Object.assign(Client.prototype, mix);
  });
};

exports.default = Client;